import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { ErrorIllustration3 } from '../icons/icons';

type OwnDeps = {
  questionsService: QuestionsService;
};
@requires(QuestionsService.serviceName)
@customElement('welcome-login-no-user-popup')
export class WelcomePopup extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        .title {
          font-weight: 700;
          font-size: 4rem;
          margin-bottom: 1.75rem;
        }
        .sub-title {
          font-size: 4rem;
          font-weight: 700;
          margin-bottom: 0;
          max-width: 61.375rem;
          color: var(--c-text-sub);
        }
      .message{
        margin:0;
        max-width:53.25rem;
        color: var(--c-text);
       } 
       
      svg, img{
        max-width: 26.5rem;
        max-height: 36.5rem;
      }
       `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  @property({ type: String })
    value: string = '';

  renderMobileLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1">
         <h1 class="title">${t('T_Welcome_No_User1')}</h1>
       </div>
       <div class="col-2">
        ${ErrorIllustration3}
      </div>
      <div class="col-3">
        <h2 class="message">${t('T_Welcome_No_User2')} ${t('T_Welcome_No_User3')}</h2>
        <h2 class="message">${t('T_Welcome_No_User4')}</h2>
      </div>
     </div>
    `;
  }

  renderDesktopLayout() {
    return html`
     <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2">
        <h1 class="title">${t('T_Welcome_No_User1')}</h1>
        <h2 class="message">${t('T_Welcome_No_User2')} ${t('T_Welcome_No_User3')}</h2>
        <h2 class="message">${t('T_Welcome_No_User4')}</h2>
      </div>
     </div>
    `;
  }

  render() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}

